import { render, staticRenderFns } from "./VhomeForm.vue?vue&type=template&id=4f8c6238&scoped=true&"
import script from "./VhomeForm.vue?vue&type=script&lang=js&"
export * from "./VhomeForm.vue?vue&type=script&lang=js&"
import style0 from "./VhomeForm.vue?vue&type=style&index=0&id=4f8c6238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c6238",
  null
  
)

export default component.exports